/* Desk Ease Co. — premium interactions (v8.1) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  /* Reveal on scroll */
  /* Safety net: never let content stay invisible. Reveals anything whose top
     has entered the viewport, even if IntersectionObserver never fires
     (throttled tab, observer failure, zero-height element, older browser). */
  function revealPassed() {
    var vh = window.innerHeight || 0;
    var rest = document.querySelectorAll('[data-dec-reveal]:not(.is-in), .dec-mask:not(.is-in)');
    for (var i = 0; i < rest.length; i++) {
      var r = rest[i].getBoundingClientRect();
      if (r.top < vh * 0.95) rest[i].classList.add('is-in');
    }
  }

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('[data-dec-reveal]:not(.is-in), .dec-mask:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    els.forEach(function (e) { io.observe(e); });
    /* If the observer has not done its job shortly after load, do it ourselves. */
    setTimeout(revealPassed, 1200);
    setTimeout(revealPassed, 4000);
  }

  /* Header state + scroll progress */
  var bar;
  function onScroll() {
    var y = window.scrollY || 0;
    root.classList.toggle('dec-scrolled', y > 40);
    if (bar) {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.setProperty('--p', h > 0 ? Math.min(1, y / h).toFixed(4) : 0);
    }
  }

  /* Count-up numbers */
  function initCounters(scope) {
    var els = (scope || document).querySelectorAll('[data-dec-count]:not([data-done])');
    if (!els.length) return;
    function run(el) {
      el.setAttribute('data-done', '');
      var target = parseFloat(el.getAttribute('data-dec-count')) || 0;
      if (reduce) { el.textContent = target; return; }
      var dur = 1600, t0 = null;
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        var eased = 1 - Math.pow(1 - p, 4);
        el.textContent = Math.round(target * eased);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Subtle parallax */
  var parallaxEls = [];
  function initParallax() {
    parallaxEls = Array.prototype.slice.call(document.querySelectorAll('[data-dec-parallax]'));
  }
  function tickParallax() {
    if (reduce || !parallaxEls.length) return;
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var r = el.parentElement.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var speed = parseFloat(el.getAttribute('data-dec-parallax')) || 0.12;
      var off = (r.top + r.height / 2 - vh / 2) * -speed;
      el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0) scale(1.12)';
    });
  }

  function init(scope) { initReveal(scope); initCounters(scope); initParallax(); }

  document.addEventListener('DOMContentLoaded', function () {
    bar = document.createElement('div');
    bar.className = 'dec-progress';
    bar.innerHTML = '<span></span>';
    document.body.appendChild(bar);
    bar = bar.querySelector('span');
    bar.parentNode.style.setProperty('--p', 0);
    bar = bar.parentNode;
    init();
    onScroll();
    tickParallax();
  });

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { onScroll(); tickParallax(); revealPassed(); ticking = false; });
  }, { passive: true });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.DecPremium = { init: init };
})();
